var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "12 12 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "svg-fill-color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M26.077 18.446a.631.631 0 0 1 0 .893l-2.923 2.922 2.923 2.923a.632.632 0 0 1 .066.814l-.066.079a.631.631 0 0 1-.893 0l-2.923-2.923-2.922 2.923a.631.631 0 0 1-.893-.893l2.922-2.923-2.922-2.922a.632.632 0 0 1-.066-.814l.066-.079a.631.631 0 0 1 .893 0l2.922 2.922 2.923-2.922a.631.631 0 0 1 .893 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M22.34 31.678a9.17 9.17 0 0 0 5.963-2.174l7.247 7.248a.83.83 0 0 0 .601.248.85.85 0 0 0 .6-1.45l-7.247-7.247a9.324 9.324 0 0 0 2.174-5.964c0-5.156-4.183-9.339-9.339-9.339C17.204 13 13 17.204 13 22.34c0 5.155 4.204 9.338 9.34 9.338zm0-16.98c4.223 0 7.64 3.437 7.64 7.641a7.636 7.636 0 0 1-7.64 7.641c-4.225 0-7.642-3.437-7.642-7.64 0-4.205 3.437-7.642 7.641-7.642z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetection);
export default __webpack_public_path__ + "static/media/detection.dfa4f4f349f36cf50cf2adacf13f33f4.svg";
export { ForwardRef as ReactComponent };